/**
 * assets/memory-upgrade-selector.js
 *
 * Single-select "Upgrade Installed Memory" chip picker. Always has a
 * value (defaults to the configured defaultSku), so unlike
 * county-selector this never blocks add-to-cart on an empty state.
 *
 * Registers a provider function with the shared ProductAddonsCore
 * controller (assets/product-addons-core.js), which owns the actual
 * add-to-cart button interception and cart/add.js submission.
 *
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    (window.memoryUpgradeConfig || []).forEach(setupInstance);
  }

  function setupInstance(config) {
    var root = document.querySelector(config.rootSelector);
    if (!root) return;

    if (!window.ProductAddonsCore) {
      console.error('memory-upgrade-selector: ProductAddonsCore not found — make sure product-addons-core.js loads first');
      return;
    }

    var chipGroup = root.querySelector('[data-memory-chip-group]');
    var errorEl = root.querySelector('[data-memory-error]');
    var variants = config.variants || [];
    var selectedSku = config.defaultSku;

    if (!variants.length) {
      showError('Memory upgrade options are not configured correctly. Contact support.');
      console.error('memory-upgrade-selector: no variants resolved — check the addon product handle and SKUs');
      // Register anyway so add-to-cart reliably blocks with a clear
      // message instead of silently shipping without this addon.
      window.ProductAddonsCore.register(root, function () {
        showError('Memory upgrade options are not configured correctly. Contact support.');
        return { ok: false };
      });
      return;
    }

    if (!variants.some(function (v) { return v.sku === selectedSku; })) {
      selectedSku = variants[0].sku; // fall back if the configured default SKU isn't present
    }

    renderChips();
    window.ProductAddonsCore.register(root, getContribution, getPriceContribution);

    function renderChips() {
      chipGroup.innerHTML = '';
      variants.forEach(function (variant) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'product__chip' + (variant.sku === selectedSku ? ' selected' : '');
        chip.dataset.sku = variant.sku;
        chip.setAttribute('aria-pressed', variant.sku === selectedSku ? 'true' : 'false');
        chip.textContent = chipLabel(variant);
        chip.addEventListener('click', function () {
          selectedSku = variant.sku;
          Array.prototype.forEach.call(chipGroup.querySelectorAll('.product__chip'), function (btn) {
            var isSelected = btn.dataset.sku === selectedSku;
            btn.classList.toggle('selected', isSelected);
            btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });
          clearError();
          if (window.ProductAddonsCore.notifyChange) window.ProductAddonsCore.notifyChange(root);
        });
        chipGroup.appendChild(chip);
      });
    }

    // Live price preview only — no validation, no error UI.
    function getPriceContribution() {
      var variant = variants.filter(function (v) { return v.sku === selectedSku; })[0];
      return variant ? Number(variant.price) : 0;
    }    

    function chipLabel(variant) {
      var sizeLabel = (variant.label && variant.label !== 'Default Title') ? variant.label : variant.sku;
      return variant.price > 0
        ? (sizeLabel + ' (+' + formatMoney(variant.price) + ')')
        : sizeLabel;
    }

    // Called by ProductAddonsCore when the shopper clicks add-to-cart.
    function getContribution() {
      var variant = variants.filter(function (v) { return v.sku === selectedSku; })[0];
      if (!variant) {
        showError('This option isn\u2019t configured correctly. Please contact support.');
        console.error('memory-upgrade-selector: selected sku not found in variants', selectedSku);
        return { ok: false };
      }

      clearError();

      // Included-at-no-cost option: don't add a $0 cart line at all. It's
      // already bundled with the product, so there's nothing to charge or
      // fulfill separately, and a stray $0 line item only creates noise
      // (and potential reconciliation problems) downstream in NetSuite.
      if (Number(variant.price) === 0) {
        return { ok: true, items: [] };
      }

      return {
        ok: true,
        items: [{
          id: variant.variantId,
          quantity: 1,
          properties: { 'Memory Card': variant.label || variant.sku }
        }]
      };
    }

    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function clearError() { errorEl.textContent = ''; errorEl.hidden = true; }
    function formatMoney(amount) { return '$' + Number(amount).toFixed(2); }
  }
})();